import { createStore, createEvent } from 'effector'
import { Aim } from './types'

export interface State {
  plan: 'BASIC' | 'OVERSEA' | 'CUSTOM'
  state?: 'CA' | 'DE'
  type?: 'CCORP' | 'LLC'
  aim?: Aim
  stateOfUS?: string
  livingInUS?: boolean
  haveSSN?: boolean
}

const initial: State = {
  plan: 'BASIC',
}

export const setState$ = createEvent<Partial<State>>()
export const setAim$ = createEvent<Aim>()

const store = createStore(initial)
  .on(setState$, (state, payload) => ({
    ...state,
    ...payload,
  }))
  .on(setAim$, (state, aim) => ({
    ...state,
    aim,
    ...(aim.value === 6
      ? { type: undefined, state: undefined }
      : {
          type: aim.value < 3 ? 'CCORP' : 'LLC',
          state: aim.value < 3 ? 'DE' : state.state,
        }),
  }))

store.watch(state => {
  if (state === initial) return
  localStorage.setItem('store$', JSON.stringify(state))
})

export const officalFeeStore = store.map(({ state, type }) => {
  if (!state || !type) return 0

  if (state === 'CA') {
    return type === 'CCORP' ? 100 : 70
  }

  return type === 'CCORP' ? 89 : 90
})

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    const stored = JSON.parse(localStorage.getItem('store$'))
    setState$(stored)
  })
}

export default store
